import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { SupportResponse } from 'src/app/models/support-response.model';
import { BaseService } from '../base/base.service';

@Injectable({
  providedIn: 'root'
})
export class MessagesService extends BaseService<SupportResponse> {
  hasUnreadMessagesChanges = new BehaviorSubject<boolean>(false);
  constructor(protected http: HttpClient) {
    super(http, 'messages');
  }

  retrieveSupportMessages(): Observable<HttpResponse<SupportResponse>> {
    return this.http.get<SupportResponse>(`${this.resourceUrl}`, {
      observe: 'response'
    });
  }

  markMessageAsRead(
    messageId: number | undefined
  ): Observable<HttpResponse<any>> {
    return this.http.patch<any>(`${this.resourceUrl}/${messageId}/read`, null, {
      observe: 'response'
    });
  }

  listArchiveDocuments(): Observable<HttpResponse<SupportResponse>> {
    return this.http.get<SupportResponse>(`${this.resourceUrl}`, {
      observe: 'response'
    });
  }
}
